var MODULE = (function (me) {
     var privateToThisFile = "something";

    // add capabilities...

     me.publicProperty = "something";

     me.init = function(){
      alert('something started');
     };

    return me;
}(MODULE || {}));



//or self executing...
(function(window, document, $, undefined){
  

})(window, document, jQuery);
